export class GetActivities {
    public static readonly type = '[Activities] Get activities';
    constructor(public partnerParam?: string, public typeParam?: string, public inTimeline?: boolean) {}
}

export class GetNextActivities {
    public static readonly type = '[Activities] Get next activities';
}
